import { QueryField, QueryFieldTypes, QueryInfo } from "./QueryInfo";
import { TFunction } from "i18next";
import { i18n } from "i18next";

export interface Agg {
  op?: string;
  field?: string;
  filter?: string[];
  include_null?: boolean;
  interval?: string | number;
  bucket_count?: number;
  sort?: object;
  aggs?: unknown;
  labels?: string[];
  label?: string;
}

export interface AggOptions {
  op?: string | null;
  field?: string | null;
  filter?: string[] | null;
  include_null?: boolean;
  labels?: string[];
  label?: string;
  interval?: string | number | null;
  bucket_count?: number | null;
  aggs?: unknown | null;
}

export interface OpOption {
  id: string;
  label: string;
}

export function aggOperatorsByType(field:QueryField, t: TFunction<["translation", ...string[]], undefined>, supportedAggregationOps: Array<string>): OpOption[] | null {
  const type:string = field.type;
  let ops: OpOption[] = [];

  const commonOps:OpOption[] = [
    {id: "min", label: t("min")},
    {id: "max", label: t("max")},
    {id: "avg", label: t("avg")},
    {id: "sum", label: t("sum")}
  ];

  if (type === QueryFieldTypes.timestamp) {
    ops = ops.concat(commonOps);
  }
  if (type === QueryFieldTypes.integer || type === QueryFieldTypes.decimal) {
    if (field.min !== undefined && field.max !== undefined) {
      ops = ops.concat(commonOps, [
        {id: "median", label: t("median")},
        {id: "percentile", label: t("percentile")}
      ]);
    } else {
      ops = ops.concat(commonOps);
    }
  }

  return ops.filter(f => supportedAggregationOps.includes(f.id));
}

export function getFieldLabelFromAgg(agg: Agg | undefined, queryInfo: QueryInfo, i18n?: i18n): string | undefined {
  if (!queryInfo || !agg || !agg.field) {
    return undefined;
  }

  const field = queryInfo?.fields?.find((field: QueryField) => field.id === agg?.field);
  let fieldLabel = field ? field.label : '';

  if (agg?.labels) {
    fieldLabel += ' - ' + agg.labels.join(', ');
  } else if (agg?.filter && field && field.options) {
    const selectedOptionsLabels = field.options.filter((option) => {
      return agg.filter?.includes(option.id as string);
    }).map((option) => option.label);
    if (selectedOptionsLabels.length > 0) {
      fieldLabel += ' - ' + selectedOptionsLabels.join(', ');
    }
  }

  if (i18n && agg.op) {
    if (["avg", "sum", "min", "max", "median"].includes(agg?.op || '')) {
      fieldLabel = `${fieldLabel} - ${i18n.t(agg.op)}`;
    }
  }
  return fieldLabel;
}
